import { withStyles } from '@material-ui/core/styles';
import ProductLinkButton from './ProductLinkButton';
import styles from './ProductLinkButton.styles';

export default withStyles(styles)(ProductLinkButton);
